import { createSelector } from "@reduxjs/toolkit";

const selectConfigBookACallText = (state) => state?.config?.bookADemoText;

export const getBookACallCtaText = createSelector(
  [selectConfigBookACallText, (_, defaultText = "TALK TO SALES") => defaultText],
  (bookACallText, defaultText) => bookACallText || defaultText,
);